import io from 'socket.io-client'

import { baseUrl } from '../constants/constant'

import { getFromSessionStorage } from '../utils/util'

class SocketIOClient {
  constructor() {
    this.socket = null

    this.connect()
  }

  connect() {
    const token = getFromSessionStorage('token')
    this.socket = io(baseUrl, {
      query: {
        token: token,
      },
    })
  }

  disconnect() {
    this.emit('logout')
    this.socket.disconnect()
  }

  on(eventName, callback) {
    this.socket.on(eventName, callback)
  }

  off(eventName, callback) {
    this.socket.off(eventName, callback)
  }

  emit(eventName, data) {
    this.socket.emit(eventName, data)
  }
}

export default SocketIOClient
